/* eslint-disable */
import {
  accountErrorFragment,
  staffErrorFragment
} from "@saleor/fragments/errors";
import { staffMemberDetailsFragment } from "@saleor/fragments/staff";
import makeMutation from "@saleor/hooks/makeMutation";
import { TypedMutation } from "@saleor/mutations";
import {
  ChangeStaffPasswordbymyself,
  ChangeStaffPasswordbymyselfVariables
} from "@saleor/staffmyself/types/ChangeStaffPasswordbymyself";
import { StaffAvatarDeletebymyself } from "@saleor/staffmyself/types/StaffAvatarDeletebymyself";
import {
  StaffAvatarUpdatebymyself,
  StaffAvatarUpdatebymyselfVariables
} from "@saleor/staffmyself/types/StaffAvatarUpdatebymyself";
// import { StaffMemberDeleteVariables } from "@saleor/staff/types/StaffMemberDelete";
import gql from "graphql-tag";
import {
  StaffUpdateByMyself,
  StaffUpdateByMyselfVariables
} from "./types/StaffUpdateByMyself";

// import { accountErrorFragment, staffErrorFragment } from "@saleor/fragments/errors";
// import { staffMemberDetailsFragment } from "@saleor/fragments/staff";
// import makeMutation from "@saleor/hooks/makeMutation";
// import { TypedMutation } from "@saleor/mutations";
// import { ChangeStaffPassword, ChangeStaffPasswordVariables } from "@saleor/staff/types/ChangeStaffPassword";
// import { StaffAvatarDelete } from "@saleor/staff/types/StaffAvatarDelete";
// import { StaffAvatarUpdate, StaffAvatarUpdateVariables } from "@saleor/staff/types/StaffAvatarUpdate";
// import { StaffMemberAdd, StaffMemberAddVariables } from "@saleor/staff/types/StaffMemberAdd";
// import { StaffMemberDelete, StaffMemberDeleteVariables } from "@saleor/staff/types/StaffMemberDelete";
// import { StaffMemberUpdate, StaffMemberUpdateVariables } from "@saleor/staff/types/StaffMemberUpdate";
// import gql from "graphql-tag";
// import {
//   StaffUpdateByMyself,
//   StaffUpdateByMyselfVariables
// } from "./types/StaffUpdateByMyself";

// import { TypedMutation } from "../mutations";
// import {
//   ChangeStaffPassword,
//   ChangeStaffPasswordVariables
// } from "./types/ChangeStaffPassword";
// import { StaffAvatarDelete } from "./types/StaffAvatarDelete";
// import {
//   StaffAvatarUpdate,
//   StaffAvatarUpdateVariables
// } from "./types/StaffAvatarUpdate";
// import {
//   StaffMemberAdd,
//   StaffMemberAddVariables
// } from "./types/StaffMemberAdd";
// import {
//   StaffMemberDelete,
//   StaffMemberDeleteVariables
// } from "./types/StaffMemberDelete";
// import {
//   StaffMemberUpdate,
//   StaffMemberUpdateVariables
// } from "./types/StaffMemberUpdate";

// const staffMemberAddMutation = gql`
//   ${staffErrorFragment}
//   ${staffMemberDetailsFragment}
//   mutation StaffMemberAdd($input: StaffCreateInput!) {
//     staffCreate(input: $input) {
//       errors: staffErrors {
//         ...StaffErrorFragment
//       }
//       user {
//         ...StaffMemberDetailsFragment
//       }
//     }
//   }
// `;
// export const TypedStaffMemberAddMutation = TypedMutation<
//   StaffMemberAdd,
//   StaffMemberAddVariables
// >(staffMemberAddMutation);

// const staffMemberUpdateMutation = gql`
//   ${staffErrorFragment}
//   ${staffMemberDetailsFragment}
//   mutation StaffMemberUpdate($id: ID!, $input: StaffUpdateInput!) {
//     staffUpdate(id: $id, input: $input) {
//       errors: staffErrors {
//         ...StaffErrorFragment
//       }
//       user {
//         ...StaffMemberDetailsFragment
//       }
//     }
//   }
// `;
// export const TypedStaffMemberUpdateMutation = TypedMutation<
//   StaffMemberUpdate,
//   StaffMemberUpdateVariables
// >(staffMemberUpdateMutation);

// const staffMemberDeleteMutation = gql`
//   ${staffErrorFragment}
//   mutation StaffMemberDelete($id: ID!) {
//     staffDelete(id: $id) {
//       errors: staffErrors {
//         ...StaffErrorFragment
//       }
//     }
//   }
// `;
// export const TypedStaffMemberDeleteMutation = TypedMutation<
//   StaffMemberDelete,
//   StaffMemberDeleteVariables
// >(staffMemberDeleteMutation);

const staffAvatarUpdateMutationbymyself = gql`
  ${accountErrorFragment}
  mutation StaffAvatarUpdatebymyself($image: Upload!) {
    userAvatarUpdate(image: $image) {
      errors: accountErrors {
        ...AccountErrorFragment
      }
      user {
        id
        avatar {
          url
        }
      }
    }
  }
`;
export const TypedStaffAvatarUpdateMutationbymyself = TypedMutation<
  StaffAvatarUpdatebymyself,
  StaffAvatarUpdatebymyselfVariables
>(staffAvatarUpdateMutationbymyself);

const staffAvatarDeleteMutationbymyself = gql`
  ${accountErrorFragment}
  mutation StaffAvatarDeletebymyself {
    userAvatarDelete {
      errors: accountErrors {
        ...AccountErrorFragment
      }
      user {
        id
        avatar {
          url
        }
      }
    }
  }
`;
export const TypedStaffAvatarDeleteMutationbymyself = TypedMutation<
  StaffAvatarDeletebymyself,
  ""
>(staffAvatarDeleteMutationbymyself);

const changeStaffPasswordbymyself = gql`
  ${accountErrorFragment}
  mutation ChangeStaffPasswordbymyself(
    $newPassword: String!
    $oldPassword: String!
  ) {
    passwordChange(newPassword: $newPassword, oldPassword: $oldPassword) {
      errors: accountErrors {
        ...AccountErrorFragment
      }
    }
  }
`;
export const useChangeStaffPasswordbymyself = makeMutation<
  ChangeStaffPasswordbymyself,
  ChangeStaffPasswordbymyselfVariables
>(changeStaffPasswordbymyself);

const staffUpdateByMyselfMutation = gql`
  ${staffErrorFragment}
  ${staffMemberDetailsFragment}
  mutation StaffUpdateByMyself($id: ID!, $input: UserInput!) {
    staffUpdateByMyself(id: $id, input: $input) {
      errors: staffErrors {
        ...StaffErrorFragment
      }
      user {
        ...StaffMemberDetailsFragment
      }
    }
  }
`;
export const TypedstaffUpdateByMyselfMutation = TypedMutation<
  StaffUpdateByMyself,
  StaffUpdateByMyselfVariables
>(staffUpdateByMyselfMutation);
